import React from 'react'
import {Map, TileLayer, Marker, Popup} from 'react-leaflet'
import L, {divIcon} from 'leaflet';


const SearchMap = ({data}) => {
    var mapData = data.filter(r => r["GPS Location"]);

    mapData.forEach(function(d) {
        d.latlong = [
            Number(d["GPS Location"].split(",")[0]),
            Number(d["GPS Location"].split(",")[1])
        ];
    })

    var state = {
        lat: 39.9826,
        lng: -75.1652,
        zoom: 11
    }

    var tiles = 'http://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}' + (
        L.Browser.retina
        ? '@2x'
        : '') + '.png';

    const position = [state.lat, state.lng];


    function geticon(item) {

        if(item["On Dist web site"] === "High") {
            return divIcon({
                className: 'groupmapmarker highschool',
                iconSize: 16,
                html: ''
            })
        } else if(item["On Dist web site"] === "Middle") {
            return divIcon({
                className: 'groupmapmarker middleschool',
                iconSize: 16,
                html: ''
            })
        } else if(item["On Dist web site"] === "Elementary") {
            return divIcon({
                className: 'groupmapmarker elementaryschool',
                iconSize: 16,
                html: ''
            })
        }

    }

    return (
        <Map scrollWheelZoom={false} center={position} zoom={state.zoom} className="mapsection">
            <TileLayer
                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy;<a href="https://carto.com/attribution">CARTO</a>.'
                url={tiles}
            />

            {
                mapData.map((item) =>
                    <Marker icon={geticon(item)} position={item.latlong} key={item.Counter}>
                        <Popup>
                            <span>
                                {item["Publication Name"]}

                                <br/>
                                <a href={`#/schools/${item["Link with ULCS"]}`}><strong>See school report <i className="fas fa-angle-right"></i></strong></a>


                            </span>
                        </Popup>
                    </Marker>
                )
        }

    </Map>)
}

export default SearchMap;



// WEBPACK FOOTER //
// ./src/components/SearchMap.js